



























































import Vue from "vue";
import moment from "moment";
import Web3 from "web3";
import { AbiItem } from "web3-utils";
import dxsalePresaleContractABI from "../assets/dxsalePresaleContractABI.json";

export default Vue.extend({
  name: "PresaleContractChecker",

  data: () => ({
    dialog: false as boolean,
    timerDisabled: true as boolean,
    loading: false as boolean,
    error: "" as string,
    presaleContract: "" as string,
    token: " " as string,
    tokenLink: "" as string,
    contractCreator: " " as string,
    contractCreatorLink: "" as string,
    presaleStartTime: " " as string,
    remaining: "" as string,
    remainingTimer: null as any,
  }),
  methods: {
    click(): void {
      this.error = "";
      this.token = " ";
      this.tokenLink = "";
      this.contractCreator = " ";
      this.contractCreatorLink = "";
      this.presaleStartTime = " ";
      this.timerDisabled = true;

      let target = "";
      try {
        target = Web3.utils.toChecksumAddress(this.presaleContract);
      } catch {
        this.error = "PresaleContract is invalid.";
        return;
      }
      const web3 = new Web3("https://bsc-dataseed1.defibit.io:443");
      const abi = dxsalePresaleContractABI as any as AbiItem;
      const contract = new web3.eth.Contract(abi, target);

      this.loading = true;
      Promise.all([contract.methods.token().call(), contract.methods.wallet().call(), contract.methods.presaleStartTime().call()])
        .then((results) => {
          this.token = results[0];
          this.tokenLink = `https://bscscan.com/address/${this.token}`;
          this.contractCreator = results[1];
          this.contractCreatorLink = `https://bscscan.com/address/${this.contractCreator}`;
          this.presaleStartTime = moment.unix(results[2]).format("YYYY/MM/DD HH:mm:ss");
          this.timerDisabled = false;
        })
        .catch((error) => {
          this.error = "Contract is not PresaleContract";
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openDialog(): void {
      this.dialog = true;
      let remaining = moment(this.presaleStartTime, "YYYY/MM/DD HH:mm:ss").diff(moment());
      if (remaining >= 0) {
        let duration = moment.duration(remaining);
        this.remaining = `${("00" + duration.days()).slice(-2)}:${("00" + duration.hours()).slice(-2)}:${("00" + duration.minutes()).slice(-2)}:${(
          "00" + duration.seconds()
        ).slice(-2)}`;
        this.remainingTimer = setInterval(() => {
          remaining = moment(this.presaleStartTime, "YYYY/MM/DD HH:mm:ss").diff(moment());
          duration = moment.duration(remaining);
          this.remaining = `${("00" + duration.days()).slice(-2)}:${("00" + duration.hours()).slice(-2)}:${("00" + duration.minutes()).slice(-2)}:${(
            "00" + duration.seconds()
          ).slice(-2)}`;
        }, 500);
      } else {
        this.remaining = "already started";
      }
    },
    closeDialog(): void {
      clearInterval(this.remainingTimer);
      this.dialog = false;
    },
  },
  watch: {
    presaleContract: function (value: string) {
      if (value == null) {
        this.error = "";
        this.token = " ";
        this.tokenLink = "";
        this.contractCreator = " ";
        this.contractCreatorLink = "";
        this.presaleStartTime = " ";
        this.timerDisabled = true;
        this.remaining = "";
        clearInterval(this.remainingTimer);
      }
    },
  },
});
